const VERSION = 'v1';

export const API_PUBLIC = '/api-public';
export const BASE_PUBLIC_API = API_PUBLIC + '/' + VERSION;

export const API = '/api';
export const BASE_API = API + '/' + VERSION;

export const API_ADMIN = '/api-admin';
export const BASE_ADMIN_API = API_ADMIN + '/' + VERSION;
